module.exports = __webpack_public_path__ + "static/img/report-banner-2020.8673c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/report-banner-2020.png
// module id = M+Pp
// module chunks = 5